'use strict';

const APPOINTMENT_TYPES = {
  NO_SHOW: 'no show',
  CANCELLED: 'cancelled',
};

angular.module('ClinicApp').controller('EditReopenAppointmentModalCtrl', function($scope, appointment, OCAppointmentUtil, OCModalUtil, $modalInstance, AppointmentService) {
  $scope.close = $modalInstance.close;

  // This modal can only be opened for cancelled or no-show appointments, so we don't need to do any more than check the status
  $scope.appointmentType = OCAppointmentUtil.isCancelled(appointment.status)
    ? APPOINTMENT_TYPES.CANCELLED
    : APPOINTMENT_TYPES.NO_SHOW;

  $scope.reopen = async () => {
    $scope.loading = true;
    try {
      await AppointmentService.resetAppointment(appointment.id);
      $scope.close();
    } finally {
      $scope.loading = false;
    }
  };

  $scope.edit = async () => {
    await OCModalUtil.showCustomModal({
      windowClass: 'verify-appointment-modal',
      templateUrl: '/views/modals/_verify-appointment.html',
      controller: 'VerifyAppointmentModalCtrl',
      resolve: OCModalUtil.createResolve({
        appointmentId: appointment.id,
      }),
    });

    $scope.close();
  };
});
